import React from "react";
import styled from "styled-components";
import { education } from "../../data/constants";
import EducationCard from "../Cards/EducationCard";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 0px 0px 60px 0px;
  @media (max-width: 960px) {
    padding: 0px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1350px;
  padding: 40px 0px 0px 0px;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: 42px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  max-width: 600px;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 16px;
  }
`;

const GlassWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  background: rgba(30, 30, 60, 0.55);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.22);
  backdrop-filter: blur(10px) saturate(180%);
  border-radius: 36px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  @media (max-width: 960px) {
    padding: 16px 8px;
    border-radius: 18px;
    gap: 18px;
  }
`;

const GradientTitle = styled(Title)`
  background: linear-gradient(90deg, ${({ theme }) => theme.primary}, ${({ theme }) => theme.text_primary});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  text-shadow: 0 2px 24px ${({ theme }) => theme.primary + '44'};
  font-weight: 800;
`;

const AnimatedBar = styled.div`
  width: 80%;
  height: 8px;
  border-radius: 8px;
  background: linear-gradient(90deg, ${({ theme }) => theme.primary} 0%, ${({ theme }) => theme.text_primary} 100%);
  box-shadow: 0 2px 12px ${({ theme }) => theme.primary + '44'};
  margin: 18px 0 24px 0;
  animation: barPulse 2.5s infinite alternate;
  @keyframes barPulse {
    0% { box-shadow: 0 2px 12px ${({ theme }) => theme.primary + '44'}; }
    100% { box-shadow: 0 2px 24px ${({ theme }) => theme.text_primary + '44'}; }
  }
`;

const Education = () => {
  return (
    <Container id="education">
      <GlassWrapper>
        <GradientTitle>Education</GradientTitle>
        <Desc style={{marginBottom: 0}}>My educational details are as follows.</Desc>
        <AnimatedBar />
        <div style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '24px'}}>
          {education.map((education, idx) => (
            <EducationCard education={education} key={idx} />
          ))}
        </div>
      </GlassWrapper>
    </Container>
  );
};

export default Education;
